import React from 'react';
import classNames from 'classnames';
import './index.scss';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon';

const SectionItemTextArea = ({ column, value, onPropChange, item }) => {
  const handleOnPropChange = e => {
    if (column.isReadonly) {
      return;
    }

    onPropChange({ [column.accessor]: e.currentTarget.value });
  };

  return (
    <div
      key={`sectionItemTextArea-${column.accessor}`}
      className={classNames('sectionItemTextArea')}
      style={{ height: column?.height }}
    >
      <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
      <textarea
        readOnly={column.isReadonly}
        className={classNames('inputItem')}
        rows='5'
        value={value || ''}
        onChange={handleOnPropChange}
        placeholder={column.placeholder}
      ></textarea>
    </div>
  );
};

export default SectionItemTextArea;
